<!-- loader.component.html -->

<div *ngIf="isLoading | async" >
    <mat-progress-bar mode="indeterminate" class="sticky"></mat-progress-bar>
</div>